import { ExpandedContent, Separator, EmptyState } from "../../Compartilhado/styles";
import { IItemHistoricoServico } from "../../../../types";
import BlocoPrincipal from "../../Compartilhado/Blocos/BlocoPrincipal";
import { CampoValor } from "../../Compartilhado/Blocos/BlocoPrincipal";

interface ExpandedContentProps {
  item: IItemHistoricoServico;
  isExpanded?: boolean;
}

function mapearDadosServicoCriado(payload: any): CampoValor[] {
  if (!payload) return [];

  const campos: CampoValor[] = [];

  if (payload.area_direito) {
    campos.push({ campo: 'Área do Direito', valor: payload.area_direito });
  }
  if (payload.servico) {
    campos.push({ campo: 'Serviço', valor: payload.servico });
  }
  if (payload.tipo_audiencia) {
    campos.push({ campo: 'Tipo de Audiência', valor: payload.tipo_audiencia });
  }
  if (payload.modalidade) {
    campos.push({ campo: 'Modalidade', valor: payload.modalidade });
  }
  if (payload.profissional) {
    campos.push({ campo: 'Profissional', valor: payload.profissional });
  }
  if (payload.creditos_padrao != null) {
    campos.push({ campo: 'Créditos Padrão', valor: String(payload.creditos_padrao) });
  }
  if (payload.modo_precificacao) {
    campos.push({ campo: 'Modo de Precificação', valor: payload.modo_precificacao === 'sob_consulta' ? 'Sob Consulta' : 'Fixo em Créditos' });
  }
  if (payload.descricao) {
    campos.push({ campo: 'Descrição', valor: payload.descricao });
  }

  return campos;
}

export default function ExpandedContentServicoCriado({ item, isExpanded }: ExpandedContentProps) {
  const payload = typeof item.payload === 'string' ? JSON.parse(item.payload) : item.payload;
  const campos = mapearDadosServicoCriado(payload);

  if (campos.length === 0) {
    return (
      <ExpandedContent>
        <Separator />
        <EmptyState>Nenhum dado disponível.</EmptyState>
      </ExpandedContent>
    );
  }

  return (
    <ExpandedContent>
      <Separator />
      <BlocoPrincipal campos={campos} />
    </ExpandedContent>
  );
}
